import React from 'react'
import { useTranslation } from 'react-i18next'

// CHILDREN
import Avatar from '../../assets/images/mock/StockProfilePic.png'
import CopyableValue from '../common/buttons/CopyableValue'

// ASSETS
import './UserRow.scss'
import { PropTypes } from 'prop-types'

const UserRow = ({ user, toggleModal }) => {
  const { t } = useTranslation()

  // A drag-selection of a cell's text ends in a click on the row; don't treat that as a request to open the modal.
  const handleRowClick = () => {
    if (window.getSelection()?.toString()) { return }

    toggleModal(user)
  }

  return (
    <div id='UserRow' role='button' tabIndex={0} className='row w-100' onClick={handleRowClick} onKeyDown={() => null}>
      <div className='col-1'>
        <CopyableValue value={user.id} label={t('users.page.col.id')} />
      </div>
      <div className='col-3'>
        <div className='smaller-round-image-wrapper'>
          <img
            src={user.avatar ? user.avatar.file_url : Avatar}
            className='round-image'
            alt={`${user.first_name} ${user.last_name}`}
          />
        </div>
        <p>
          {user.first_name} {user.last_name}
        </p>
      </div>
      <div className='col-1'>
        <p>{user.type}</p>
      </div>
      <div className='col-3'>
        <p>{user.email ? user.email : user.username}</p>
      </div>
      <div className='col-3'>
        <p>
          {user.communities && user.communities.length > 0
            ? user.communities[0].name
            : t('users.userRow.notAvailable')}
        </p>
      </div>
      <div className='col-1'>
        {user.oauth_external_id && (
          <CopyableValue value={user.oauth_external_id} label={t('users.page.col.idpId')} />
        )}
      </div>
    </div>
  )
}

UserRow.propTypes = {
  user: PropTypes.object,
  toggleModal: PropTypes.func,
}

export default UserRow
